import React, { Fragment, useContext, useEffect, useCallback } from "react";
import { WscCustomForm } from 'wsc-react-custom-form';
import { useCommonStore } from "@/store/useCommonStore";
import useRequest from "@/utils/useRequest";
import Config from "@/config";
import {
  FormCode, FlowDict, FormNodeSwitch, FormDateTimeSelect, FormIdTypeSelect,
  FormDeptTreeSelect, FormRoleSelect, FormAreaSelect, FormIconSelect,
  FormColorSelect, FormImageUpload, FormQuillEditor, FormUserSelect,
  FormMenuFuncSelect, FormRoleMenuFuncSelect, FormCategoryTreeSelect
} from '@/component/exComponents';
import { CustomFormContext } from "./CustomFormContext";
import ReactDOM from 'react-dom'

const Loading = React.memo(() => {
  const domEl = document.querySelector('body')

  if (!domEl) return null

  // This is where the magic happens -> our modal dsiv will be rendered into our 'modal-root' div, no matter where we
  // use this component inside our React tree
  return ReactDOM.createPortal(
    <div className="modal flex justify-center items-center space-x-2 text-white-600">
      <svg className="animate-spin -ml-1 mr-3 h-8 w-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"></circle>
        <path className="opacity-75" fill="#1890ff" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      加载中...
    </div>,
    domEl
  )
});

const Modal = React.memo(({ children }) => {
  const domEl = document.querySelector('body')

  if (!domEl) return null

  // This is where the magic happens -> our modal dsiv will be rendered into our 'modal-root' div, no matter where we
  // use this component inside our React tree
  return ReactDOM.createPortal(
    <div className="modal flex-1 h-full">
      {children}
    </div>,
    domEl
  )
})

const UseWscCustomFormModal = (props) => {
  const { setLoading,
    setVisible,
    putCustomform } = useContext(CustomFormContext);
  //const { OnPayload } = props;
  const { request } = useRequest();
  const loadSchema = async (id, formdata) => {
    setLoading(id, true);
    const result = await request("/api/v2/private/dynamicform/schema/get", "POST", "json", { id: id });
    setLoading(id, false);
    if (result.success) {
      //setFormdata(formdata);
      putCustomform(id, { loading: false, schema: result.data.Data, formdata: formdata, visible: true })
    }
    return null;
  }

  const hide = (id) => {
    setVisible(id, false);
  }

  const showDynamicModal = useCallback((id, formdata) => {
    loadSchema(id, formdata);
  });

  return { showDynamicModal, hide, WscCustomFormModal };
}

const WscCustomFormModal = ({ formId, OnPayload }) => {
  //const { show, hide, CustomFormModal } = useCustomFormModal();
  const { setVisible, getCustomForm } = useContext(CustomFormContext);
  const { loading, schema, formdata, visible } = getCustomForm(formId);
  const user = useCommonStore.use.user();
  const sysdicts = useCommonStore.use.sysdicts();
  return <Fragment>
    {loading ? <Loading /> : null}
    {visible && <Modal
      closeModal={() => {
        setVisible(formId, false);
      }}
      centered
    >{schema ? <WscCustomForm
      schema={schema}
      OnPayload={OnPayload}
      exComponents={[FormCode, FlowDict, FormNodeSwitch, FormDateTimeSelect, FormIdTypeSelect,
        FormDeptTreeSelect, FormRoleSelect, FormAreaSelect, FormIconSelect,
        FormColorSelect, FormImageUpload, FormQuillEditor, FormUserSelect,
        FormMenuFuncSelect, FormRoleMenuFuncSelect, FormCategoryTreeSelect]}
      formdata={formdata}
      sysdicts={sysdicts}
      baseURL={Config.ApiHost}
      headers={{ "Authorization": user.auth.name, "wsctoken": user.auth.token }}
    /> : null}
    </Modal>}
  </Fragment>;
}

export default UseWscCustomFormModal;